export default __webpack_public_path__ + "static/media/1171.5224c96d.png";